.actions {
  position: fixed !important; // override draggable plugin
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(calc(50vw - 100% - 14px));
  z-index: 21 !important; // override draggable plugin
  // width: 154px;
  padding: 0 1em 1em;
  background: rgba(255,255,255,0.8);
  font-size: 16px;
  line-height: 1.1;

  &.isFullscreen {
    transform: translateY(-50%) translateX(0);
  }

  & > li {
    margin: 8px 0 0;
    cursor: pointer;
    user-select: none;


    &:first-child {
      margin-top: 0;
    }

    &.handle {
      cursor: move;
      padding: 12px 0;
      margin-bottom: -4px;
    
      span {
        display: block;
        height: 2px;
        background: gray;
      }
    }

    &.remove {
      margin-bottom: 18px;
    }
    
    &.disabled {
      // cursor: auto;
      // opacity: 0.5;
      // pointer-events: none;
      display: none;
    }    
  }

  &.minimized li:not(.handle) {
    display: none;
  }
}


.zoomButtons {
  cursor: auto !important;

  span {
    cursor: pointer;
    font-size: 18px;
    padding: 0 2px;
  }
}